<div (click)="toggleConnectionElementClicked()">
  @if ((serviceConnected$ | async) === true) {
    @if (useAlternateStyling) {
      <ng-content select="integrations-disconnect-element"></ng-content>
    } @else {
      <button mat-raised-button>
        {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECT_TO_SERVICE_ELEMENT.DISCONNECT_SERVICE' | translate }}
      </button>
    }
  } @else {
    @if (useAlternateStyling) {
      <ng-content select="integrations-connect-element"></ng-content>
    } @else {
      <button mat-raised-button>
        {{ 'FRONTEND.MEETING_INTEGRATIONS.CONNECT_TO_SERVICE_ELEMENT.CONNECT_SERVICE' | translate }}
      </button>
    }
  }
</div>






